import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button';
import { MobileNav } from './mobile-nav';
import { applyTheme, getCurrentTheme, setTheme, type Theme } from '@/lib/theme';

export function Topbar(): JSX.Element {
  const [theme, setLocalTheme] = useState<Theme>('light');

  useEffect(() => {
    const current = getCurrentTheme();
    setLocalTheme(current);
    applyTheme(current);
  }, []);

  function toggle(): void {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    setLocalTheme(next);
    setTheme(next);
  }

  return (
    <header className="flex h-14 items-center justify-between border-b bg-background px-4 md:px-6">
      <div className="flex items-center gap-2">
        <MobileNav />
        <div className="text-sm font-medium text-muted-foreground">
          Comptabilité crypto &amp; générateur de FEC
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={toggle} aria-label="Basculer thème">
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
      </div>
    </header>
  );
}
